<template>
  <div class="login">
    <AwHeader class="login_header" ref="login_header"></AwHeader>
    &lt;!&ndash;
    <nav :class="nav_show"></nav>
    &ndash;&gt;
    <div class="box">
      <img :src="backgroundImg" alt="" class="background-img" />
      <el-card class="container-login" ref="loginCard">
        <div class="headerToggle">
          <h2 style="color: #000">登录</h2>
          <!-- <span class="pull-right" style="color: #000"
            >没有账号？<router-link :to="'/signup?pid=' + $route.query.pid"
              >点击注册</router-link
            ></span
          > -->
        </div>
        <!-- &lt;!&ndash; 登录表单区域&ndash;&gt; -->
        <div class="scan">
          <img
            style="width: 400px"
            :src="scanimg"
            alt="扫码登录"
            @click="weChatScanCodeImg"
          />
        </div>
        <p
          class="user-select-none"
          style="
            text-align: center;
            color: #fff;
            margin-top: 12px;
            font-family: SourceHanSansCN-Regular, serif;
          "
        >
          请使用
          <!--          <span class="pointer" style="color: #ffa200" @click="downloadDialog = true"-->
          <!--        >微信 扫一扫 或 竞技传奇公会App</span>-->
          <span class="pointer" style="color: #ffa200">微信 扫一扫</span>
          扫码登录
        </p>
        <!-- <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginFormRules"
          label-width="0"
          class="login_form"
        >
       
          <el-form-item prop="username">
            <el-input
              placeholder="用户名"
              v-model="loginForm.username"
              prefix-icon="el-icon-user-solid"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
        
          <el-form-item prop="password">
            <el-input
              placeholder="密码"
              type="password"
              v-model="loginForm.password"
              @keyup.enter.native="login"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
       
          <el-form-item prop="codedata">
            <el-input
              placeholder="验证码"
              type="text"
              v-model="loginForm.codedata"
              style="width: 70%"
              @keyup.enter.native="login"
              prefix-icon="el-icon-key"
            ></el-input>
            <el-image
              style="
                width: 30%;
                height: 40px;
                margin-left: 10px;
                border-radius: 4px;
              "
              @click="getCodeImg"
              :src="`data:image/png;base64,${verificationCode}`"
            ></el-image>
          </el-form-item>
          <router-link :to="'/forgotPassword?pid=' + $route.query.pid">
            <span class="pull-right pointer" style="color: #000"
              >忘记密码？</span
            ></router-link
          >
      
          <el-form-item class="btns">
            <el-button round type="primary" @click="login">登录</el-button>
            <el-button round type="info" @click="resetLoginForm"
              >重置</el-button
            >
          </el-form-item>
        </el-form> -->
      </el-card>
      <router-view></router-view>
    </div>
    <AwFooter></AwFooter>
  </div>
</template>

<script>
import AwHeader from "../components/public/Header.vue";
import AwFooter from "../components/public/Footer";
import { createLogger, mapState } from "vuex";
import { get, post } from "@/utils/http";
import { setToken, getUserIP } from "@/utils/auth";
import { eventLogin, eventIsLogin } from "@/main";
import { v4 as uuidv4 } from "uuid";
import { debounce } from "lodash";
export default {
  name: "index",
  components: {
    AwFooter,
    AwHeader,
  },
  data() {
    return {
      fingerprint: "", //浏览器指纹
      scanimg: require("../assets/img/scanCodeErr.webp"),
      userIp: "",
      verificationCode: "",
      nav_show: "",
      backgroundImg: require("../assets/img/login_1.png"),
      // 这是登录表单
      loginForm: {
        username: "",
        password: "",
        codedata: "",
      },
      pollingInterval: null,
      timeout: null,
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名名是否合法
        username: [
          { required: true, message: "请输入登录名称", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
          // { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/, message: '用户名是由英文字母和数字组成的哦', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: "用户名需要包含字母或数字",
            trigger: "blur",
          },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: "密码需要包含字母或数字",
            trigger: "blur",
          },
        ],
        codedata: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  computed: mapState(["BannerHeight"]),
  created() {
   
    // this.getCodeImg();
    this.loginForm = {
      username: "",
      password: "",
      codedata: "",
    };
    getUserIP().then((res) => {
      console.log(res.data.data);
      
      this.userIP = res.data.data;
    });
  },
  methods: {
    getUUID() {
      const uuid = uuidv4();
      console.log("UUID:", uuid);
      // 存储在 localStorage 中
      this.fingerprint = uuid;
      localStorage.setItem("deviceUUID", uuid);
      console.log(this.fingerprint);
    },

    weChatScanCodeImg: debounce(function () {
      console.log("触发获取微信扫码（lodash防抖）");
      get(
        `/system/verdata/wx2w?uid=${this.fingerprint}&channel=weChat&sources=weChat&uip=${this.userIP}`
      )
        .then((res) => {
          console.log(res);
          this.scanimg = "data:image/png;base64," + res.msg;
          this.starPolling(this.fingerprint);
        })
        .catch((err) => {
          console.error(err);
        });
    }, 1000), // 防抖间隔1000ms
    starPolling(uuid) {
      // 设置30秒超时
      this.timeout = setTimeout(() => {
        clearInterval(this.pollingInterval);
        this.scanimg = require("../assets/img/scanCodeErr.webp");
      }, 60000);
      // 每2秒轮询一次
      this.pollingInterval = setInterval(() => {
        get(`/system/verdata/wxstate?uid=${uuid}`)
          .then((res) => {
            console.log(res);
            if (res.data.states) {
              setToken(res.data.token);
              clearInterval(this.pollingInterval);
              this.scanimg = require("../assets/img/scanCodeErr.webp");
              console.log("扫码登录成功");
              get("/system/user/userdatas")
                .then(async (res) => {
                 // console.log(res.data, "扫码用户信息");
                  localStorage.setItem("userinfo", JSON.stringify(res.data));
                  this.$message.success(res.msg);
                  //this.getCodeImg();
                  this.$router.push(
                    "/user-center?pid=" + this.$route.query.pid
                  );
                  this.$store.commit("setNavDarkActive", {
                    navDarkActive: false,
                  });
                  // 发送事件通知
                  eventLogin.$emit("userLoggedIn");
                })
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }, 5000);
    },
    //获取验证码图片
    getCodeImg() {
      get("/system/verdata/yan")
        .then((res) => {
          // console.log(res);
          this.verificationCode = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击重置按钮，重置登录表单
    resetLoginForm() {
      // console.log(this)
      this.$refs.loginFormRef.resetFields();
    },
    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return;
        this.loginForm.pid = this.$route.query.pid;
        this.loginForm.uip = this.userIp;
        post("/system/verdata/login", this.loginForm)
          .then((res) => {
            // console.log(res);
            let serveTimes = Number(res.times);
            let clientTimes = Math.floor(new Date().getTime() / 1000);
            let servetimeCha = serveTimes - clientTimes;
            localStorage.setItem("servetimeCha", servetimeCha);
            setToken(res.data);
            this.$message.success(res.msg);
            //this.getCodeImg();
            this.$router.push("/user-center?pid=" + this.$route.query.pid);
            this.$store.commit("setNavDarkActive", {
              navDarkActive: false,
            });
            // 发送事件通知
            eventLogin.$emit("userLoggedIn");
            //eventIsLogin.$emit('userIsLogin')
          })
          .catch((err) => {
            console.log(err);
            this.getCodeImg();
          });
        // const { data: res } = await this.$http.post('/web/login', this.loginForm)
        // console.log(res)
        // if (res.status !== 200) {
        //     return this.$message.error('登录失败')
        // } else {
        //     this.$message.success('登录成功')
        //     // console.log(res)
        //     // 1、保存 token 到 sessionStorage 中
        //     window.sessionStorage.setItem('token', res.data.token)

        //     // 2、编程式导航：页面跳转
        //     await this.$router.push('/admin')
        //     // this.$store.commit('setNavDarkActive', {
        //     //   navDarkActive: false
        //     // })
        // }
      });
    },
  },
  mounted() {
    this.getUUID();
    this.$store.commit("setHeaderLogo", {
      headerLogoShow: false,
    });
    this.$store.commit("setShadowActive", {
      headerShadowActive: false,
    });
    this.$store.commit("setNavDarkActive", {
      navDarkActive: true,
    });
    this.$store.commit("setHeaderShow", {
      headerShow: false,
    });
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (from.name === "login") {
      this.$store.commit("setNavDarkActive", {
        navDarkActive: false,
      });
      this.$store.commit("setHeaderLogo", {
        headerLogoShow: true,
      });
      next();
    }
  },
};
</script>

<style lang="less" scoped>
.login {
  //min-height: 800px;
  position: relative;
}

.login_header {
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  //border-bottom: 1px solid #f8f8f8;
}

.box {
  padding-top: -10px;
  width: 100%;
  height: 763px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #f2f2f2;
}

.background-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  //z-index: -1;
}

.container-login {
  min-width: 480px;
  margin-bottom: 50px;
  padding: 35px;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  border: none;

  .headerToggle {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 24px;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
  }

  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;

    // .el-button {
    //     //margin-right: 80px;
    // }

    .el-input__inner {
      background-color: rgba(255, 255, 255, 0.5);
      border: none;
    }

    input::placeholder {
      color: #818181;
    }
  }

  // .pull-right {}
}
</style>
